import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Content, Header, Page } from '@backstage/core-components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const GuestSupportPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Support | TRATON Developer Portal';
  }, []);

  return (
    <Page themeId="documentation">
      <Header title="Getting support with login and access" />
      <Content>
        <Button
          variant="text"
          startIcon={<ArrowBackIcon sx={{ fontSize: 24 }} />}
          onClick={() => navigate('/')}
          sx={{
            marginBottom: '24px',
            '& .MuiButton-startIcon': { ml: 0, mr: '6px' },
          }}
        >
          Back to Login
        </Button>

        <Typography variant="h5" gutterBottom>
          Need help or have questions?
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: '24px' }}>
          Reach out to the platform team via your internal support channels. If
          you are not sure where to go, contact your manager for guidance.
        </Typography>

        <Typography variant="h5" gutterBottom>
          Request access to Traton Developer Portal
        </Typography>
        <Typography variant="body1" paragraph>
          Contact your manager or submit a request through the standard IT
          helpdesk process.
        </Typography>
      </Content>
    </Page>
  );
};
